import request from "@/utils/request";

// 获取账号列表
export function fetchGetAccountList(data) {
  return request({
    url: "/api/AdminUserMethod/GetAccountList",
    method: "post",
    data
  });
}

// 编辑账号
export function fetchEditAccount(data, type) {
  const url = {
    add: "/api/AdminUserMethod/AddAccount", // 新增
    edit: "/api/AdminUserMethod/UpdateAccount" // 编辑
  };
  return request({
    url: url[type],
    method: "post",
    data
  });
}

// 删除账号
export function fetchDelAccount(data) {
  return request({
    url: "/api/AdminUserMethod/DelAccount",
    method: "post",
    data
  });
}

// 获取账号权限下拉数据
export function fetchGetRoleList(data) {
  return request({
    url: "/api/AdminUserMethod/GetRoleList",
    method: "post",
    data
  });
}

// 获取当前登录用户头像(阿里云签名存在有效期，前端过期后需要重新获取)
export function fetchGetLoginUserHeadPhoto(data) {
  return request({
    url: "/api/AdminUserMethod/GetLoginUserHeadPhoto",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/chat/AccountManagement.js